import PropTypes from "prop-types";
import React from "react";

const DataStatus = ({isErrorResponse, isLoadingData, data, errorResponse, messageError, isSubmitingData=null})=>{
    return ( 
        <>
       { (isErrorResponse && !isSubmitingData && !isLoadingData && data.length===0) &&
        <div className="error-message border-content pt-4 pb-4">
          <span className="">Error: {errorResponse?.toString()}</span>
        </div>}
      {(isLoadingData) &&
        <div className="border-content pt-4 pb-4 custom-icon-loading">
          <i className="fas fa-spinner fa-spin"></i>
        </div>}
      {((data.length === 0 && !isLoadingData && !isErrorResponse && isSubmitingData)) &&
        <div className="element-row-message border-content pt-4 pb-4 ">
          <span>{messageError}</span>
        </div>}
      {((data.length === 0 && !isLoadingData && !isErrorResponse && isSubmitingData === null)) &&
        <div className="element-row-message border-content pt-4 pb-4 ">
          <span>{messageError}</span>
        </div>}
          {
           (!isSubmitingData && !isLoadingData && !isErrorResponse && isSubmitingData !== null && data.length === 0   ) &&
              <div className="element-row-message border-content pt-4 pb-4">
                <span>Ejecute una b&uacute;squeda para obtener resultados.</span>
              </div>
          }
        </>
)
}
DataStatus.propTypes={
    isErrorResponse: PropTypes.bool,
    isLoadingData: PropTypes.bool,
    data: PropTypes.any,
    errorResponse: PropTypes.any,
    messageError: PropTypes.string,
    isSubmitingData: PropTypes.bool
}
export default DataStatus;